<template>
    <div>
        <div  class="container-fluid mb-5">

            <div class="white-bg mb-3 mt-4 d-flex justify-content-between">
                <div class="">
                    <h4 class="headings">Property Informations</h4>
                    <h6 class="subheadings d-none d-sm-block">Here are all the details of this property, click button to edit or update details </h6>
                </div>
                <!-- <div>
                    <button class="btn greyButton">Edit details</button>
                </div> -->
            </div>
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>

            <div class="property-details white-bg">
                <h5 class="headings">Property details</h5>

                <div class="row">
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property ID</h6>
                            <h5>{{ propertyDetails.batch }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property plane type</h6>
                            <!-- <h5>{{propertyDetails.plan_type}}</h5> -->
                            <h5>---</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property plane type expiration date</h6>
                            <h5>---</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property type</h6>
                            <h5>{{ propertyDetails.typename }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property subtype</h6>
                            <h5>{{propertyDetails.subtypename}}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Total rent value</h6>
                            <h5>{{ Number(outterDetails.rent_value).toLocaleString() }}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Total number of tenant </h6>
                            <h5>{{ outterDetails.number_of_tenant }}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Address </h6>
                            <h5>{{propertyDetails.address}}</h5>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="propertyDetails.facility_manager != null">
                        <div class="details-item">
                            <h6>Assigned FMC</h6>
                            <h5>{{ propertyDetails.facility_manager.firstname }} {{ propertyDetails.facility_manager.lastname }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property lawyer</h6>
                            <h5>---</h5>
                        </div>
                    </div>
                </div>

            </div>

            <div class="white-bg mb-4">
                <h5 class="headings">Unit Tenant Info</h5>

                <div class="d-flex justify-content-between">
                    <div class="mb-3 col-md-4 pl-0">
                        <input type="text" v-model="search" class="form-control" placeholder="Search by name, unit number">
                    </div>

                    <div class="add-tenant-btn">
                        <button class="btn" data-toggle="modal" data-target="#addTenantToUnit">Add Tenant</button>
                    </div>

                    <!-- Modal to add new tenant to  -->
                    <div class="modal fade" id="addTenantToUnit" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="addTenantToUnitLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="addTenantToUnitLabel">Add tenent to unit</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="modal-input">
                                    <div class="form-group">
                                        <label for="email">Tenant email:</label>
                                        <div class="d-flex justify-content-between" style="gap:7px;">
                                            <input class="form-control" v-model="email" type="email" name="email" id="email" placeholder="Search tenant email" required>
                                            <button :disabled="loadingUser" class="btn search-btn" @click="searchUser()">
                                                {{ loadingUser ? 'Searching...' : 'Search' }}
                                    
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="searchDone && !loadingUser">
                                        <div class="form-group">
                                            <label for="email">First name:</label>
                                            <input :disabled="userFound" v-model="firstname" class="form-control" type="text" name="fullname" id="fullname" placeholder="Enter first name" required>
                                        </div>
                                        <div class="form-group">
                                            <label for="email">Last name:</label>
                                            <input :disabled="userFound" v-model="lastname" class="form-control" type="text" name="lastname" id="lastname" placeholder="Enter last name" required>
                                        </div>
                                        <div class="form-group">
                                            <label for="email">Phone number:</label>
                                            <input :disabled="userFound" v-model="phone" class="form-control" type="text" name="number" id="number" placeholder="Enter phone number" required>
                                        </div>
                                        <!-- <div class="form-group">
                                            <label for="email">Gender:</label>
                                            <select :disabled="userFound" class="form-control" name="gender" id="gender" v-model="gender">
                                                <option value="" selected disabled>Select gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Male</option>
                                            </select>
                                        </div> -->
                                        <div class="form-group">
                                            <label for="email">Unit:</label>
                                            <select class="form-control" name="unitname" id="unit" v-model="property" @change="unitDataChange">
                                                <option value="" selected disabled>Select Unit</option>
                                                <option v-for="(item, index) in unitsData" :key="index" :value="item" >{{item.nomenclature_serial}}</option>
                                                <!-- <option value="Unit 1">IFA</option> -->
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="date">Rent due date:</label>
                                            <input v-model="rentDueDate" class="form-control" type="date" name="date" id="date" placeholder="Rent Due date" required>
                                        </div>
                                        <div class="form-group">
                                            <label for="date">Amount:</label>
                                            <input disabled v-model="amount" class="form-control" type="number" name="amount" id="amount" placeholder="Rent Due date" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer" v-if="searchDone">
                                <button type="button" class="btn cancel-submit" data-dismiss="modal">Close</button>
                                <button type="button" class="btn submit-tenant" v-if="!userFound" @click="createAccount()">
                                    {{ creatingAccount ? 'Processing...' : ' Create Tenant' }}
                                   
                                </button>
                                <button type="button" class="btn submit-tenant" v-if="userFound" @click="addTenantToUnit()">
                                    {{ addingTenant ? 'Processing...' : 'Submit' }}
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal to add new tenant to unit -->
                </div>

                <div class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Unit</th>
                                <th scope="col">Tenant Name</th>
                                <th scope="col">Tenant Phone</th>
                                <th scope="col">Payment Type</th>
                                <th scope="col">Rent Due Date</th>
                                <th scope="col">Amount</th>
                                <!-- <th scope="col">Status</th> -->
                                <!-- <th scope="col">Actions</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <tr>
                                <td>1</td>
                                <td>Uzo Man</td>
                                <td>Safe</td>
                                <td>2/12/2025</td>
                                <td>Occupied</td>
                            </tr> -->
                            <!-- v-for="(item, index) in landlords"
                                :key="index" -->
                            <tr v-for="(item, index) in filteredTenant"
                                :key="index">
                                <td>{{ item.unit }}</td>
                                <td>{{ item.tenant.firstname }} {{ item.tenant.lastname }}</td>
                                <td>{{ item.tenant.phone }}</td>
                                <td>{{item.payment_type == 'R' ? 'Regularised' : '', item.payment_type == 'H' ? 'Harmonized' : '', item.payment_type == 'G' ? 'Guaranteed' : '', }}</td>
                                <td>{{ item.rent_due_date | moment2 }}</td>
                                <td>&#8358;{{ Number(item.amount).toLocaleString() }}</td>
                                <!-- <td>{{ item.status }}</td> -->
                                <!-- <td class="occupied credit"><span>{{item.status}}</span></td> -->
                                <!-- <td style="color: #0033EA">
                                    View more
                                </td> -->
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="filteredTenant.length == 0" class="empty-state mt-5 mb-5">
                            <img src="../assets/icons/emptycan-state.svg" alt="empty">
                            <h5>No tenant data available</h5>
                        </div>
                    <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                        <EmptyState :emptyData="emptyDataObject2" />
                    </div> -->
                </div>
            </div>

            <div class="white-bg mb-4 d-none">
                <div>
                    <h5 class="headings">Property personnels</h5>
                    <h6 class="subheadings">Here are all the personnels on this property</h6>
                </div>
                <div class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Personnel Type</th>
                                <th scope="col">Name</th>
                                <th scope="col">Company</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Email</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- v-for="(item, index) in tenantsdetails"
                                :key="index" -->
                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr>   

                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr> 
                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr> 
                    
                        </tbody>
                    </table>
                    <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                        <EmptyState :emptyData="emptyDataObject2" />
                    </div> -->
                </div>
            </div>

            <div class="white-bg mb-4">
                <div>
                    <h5 class="headings">Rent payment history</h5>
                </div>

                <div class="payment-history">
                    <div class="row">
                        <div class="col-md-6" v-for="(item, index) in rentDisbursment"
                                :key="index">
                            <div class="history-holder">
                                <h4>Unit {{ item.unit_name }}</h4>
                                <h5>Paid amount: ₦{{Number(item.amount).toLocaleString()}}</h5>
                                <h5>Tenant name: {{item.user.firstname}} {{ item.user.lasttname }}</h5>
                                <div class="text-right">
                                    <small>
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.50975 2.02344C4.21428 2.02344 1.5332 4.70452 1.5332 7.99998C1.5332 11.2954 4.21428 13.9765 7.50975 13.9765C10.8052 13.9765 13.4863 11.2954 13.4863 7.99998C13.4863 4.70452 10.8052 2.02344 7.50975 2.02344ZM7.50975 12.7812C4.87349 12.7812 2.72851 10.6362 2.72851 7.99998C2.72851 5.36373 4.87349 3.21875 7.50975 3.21875C10.146 3.21875 12.291 5.36373 12.291 7.99998C12.291 10.6362 10.146 12.7812 7.50975 12.7812Z" fill="#374151"/>
                                            <path d="M8.10742 5.01172H6.91211V8.59764H10.498V7.40234H8.10742V5.01172Z" fill="#374151"/>
                                        </svg>
                                         {{item.date | moment3}}
                                    </small> 
                                    <small>
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.60156 7.40234H5.79687V8.59765H4.60156V7.40234ZM4.60156 9.79296H5.79687V10.9883H4.60156V9.79296ZM6.99218 7.40234H8.18749V8.59765H6.99218V7.40234ZM6.99218 9.79296H8.18749V10.9883H6.99218V9.79296ZM9.3828 7.40234H10.5781V8.59765H9.3828V7.40234ZM9.3828 9.79296H10.5781V10.9883H9.3828V9.79296Z" fill="#374151"/>
                                            <path d="M3.40625 13.9765H11.7734C12.4326 13.9765 12.9687 13.4404 12.9687 12.7812V4.41406C12.9687 3.75484 12.4326 3.21875 11.7734 3.21875H10.5781V2.02344H9.38279V3.21875H5.79686V2.02344H4.60156V3.21875H3.40625C2.74703 3.21875 2.21094 3.75484 2.21094 4.41406V12.7812C2.21094 13.4404 2.74703 13.9765 3.40625 13.9765ZM11.7734 5.60936L11.774 12.7812H3.40625V5.60936H11.7734Z" fill="#374151"/>
                                        </svg>

                                        {{item.date | moment2}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="rentDisbursment.length == 0" class="empty-state mt-5 mb-5">
                        <img src="../assets/icons/emptycan-state.svg" alt="empty">
                        <h5>No available rent payment data yet</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import '@/assets/styles/custom.scss';
import PageLoader from "./PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import moment from "moment";
import $ from "jquery";

export default {
    name: "LandlordProperties2",
    components: {
        PageLoader
    },
    data() {
        return {
            loading: false,
            batchNum: this.$route.params.id,
            propertyDetails: [],
            personnels: [],
            rentDisbursment: [],
            tenantsdetails: [],
            outterDetails: {},
            search: "",
            loadingUser: false,
            searchDone: false,
            addingTenant: false,
            creatingAccount: false,
            email: "",
            fistname: "",
            lastname: "",
            phone: "",
            gender: "",
            unitsData: [],
            rentDueDate: "",
            userFound: false,
            tenantId: "",
            property: "",
            amount: "",
            tenantData: "",
        }
    },
    watch: {
        '$route.params.id'(routeId) {
            this.batchNum = routeId
        }
    },
    computed: {
        filteredTenant() {
            return this.tenantsdetails.filter((item) =>
                item.tenant.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                item.tenant.lastname.toLowerCase().includes(this.search.toLowerCase()) ||
                item.tenant.phone.includes(this.search.toLowerCase()) ||
                item.unit.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        formattedDate() {
        
            if (!this.rentDueDate) return '';
            // Extracts characters from index 5 to the end ("09-11")
            return this.rentDueDate.substring(5); 
                    
            // if (!this.rentDueDate) return '';
            // // Create a date object (using UTC to avoid time zone shifts)
            // const [year, month, day] = this.rawDate.split('-');
            // const date = new Date(year, month - 1, day);
            
            // // Format to show only Month and Day (e.g., "September 9" or "09/09")
            // return date.toLocaleDateString('en-US', {
            //     month: 'long',
            //     day: 'numeric'
            // });
        }
    },
    async mounted() {
        await this.fetchPropertyDetails();
        await this.fetchBatchUnits()
    },
    methods: {
        unitDataChange() {
            this.amount = this.property.price;
        },
        createAccount() {
            this.creatingAccount = true;
            Api.postRequest(`create-user`, {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                phone: this.phone,
                // genger: this.gender,
            }).then(res => {
                // console.log("Create Response", res)
                this.creatingAccount = false;
                if (res.data.success === 'success') {
                    this.tenantData = res.data.user;
                    this.userFound = true;
                    return this.$store.commit(
                        "setApiSuccess",
                        'Tenant record created successfully'
                    );
                }
                if (res.data.error) {
                    return this.$store.commit(
                        "setApiFailed",
                        res.data.error
                    ); 
                }
            }).catch(err => {
                console.log("error", err);
                this.creatingAccount = false;
            })
        },
        async searchUser() { 
            if(this.email === '') {
                return this.$store.commit(
                    "setApiFailed",
                    "Enter tenant email"
                );  
            }
            this.loadingUser = true;
            try {
                await Api.getRequest(`checkuserwithemailexist/${this.email}`).then(res => {
                    this.loadingUser = false;
                    if (res.data.success == 'success') {
                        this.searchDone = true;
                        if (res.data.message === 'user found') {
                            this.userFound = true;
                            // this.email = res.data.user.email;
                            this.lastname = res.data.user.lastname;
                            this.firstname = res.data.user.firstname;
                            this.phone = res.data.user.phone;
                            this.tenantData = res.data.user;
                        }
                        else {
                            this.userFound = false;
                            // this.email = "";
                            this.lastname = "";
                            this.firstname = "";
                            this.phone = '';
                        }
                    }
                    return this.$store.commit(
                        "setApiSuccess",
                        res.data.message
                    );
                }).catch(err => {
                    console.log("Error", err);
                    this.searchDone = false;
                    this.loadingUser = false;
                })
            } finally {
                this.loadingUser = false;
                // this.searchDone = false;
                // console.log('closed');
            }
        },
        async addTenantToUnit() {
            this.addingTenant = true;
            try {
                Api.postRequest(`process-add-tenant-to-unit`, {
                    property_id: this.property.id,
                    tenant_user_id: this.tenantData.id,
                    rent_due_date: this.formattedDate,
                    amount: this.amount,
                }).then(res => {
                    // console.log("Response added", res)
                    this.addingTenant = false;
                    if (res.data.success === 'success') {
                        this.fetchPropertyDetails();
                        this.fetchBatchUnits()
                        $("#addTenantToUnit")
                        .removeClass("fade")
                        .modal("hide");
                        return this.$store.commit(
                            "setApiSuccess",
                            "Tenant added to unit successfully"
                        );
                    }
                    if (res.data.error) {
                        return this.$store.commit(
                            "setApiFailed",
                            res.data.error
                        ); 
                    }
                }).catch(err => {
                    console.log("ERROR", err);
                    this.addingTenant = false;
                })
            } finally {
                // console.log("closed")
            }
        },
        async fetchBatchUnits() {
            try {
                await Api.getRequest(`fetch-units-in-batch/${this.batchNum}`).then(res => {
                    this.unitsData = res.data.units
                }).catch(err => {
                    console.log("ERROR", err);
                })
            } finally {
                // console.log("Closed")
            }
        },
        async fetchPropertyDetails() {
            this.loading = true;
        // this.loader = true;
        try {
            await Api.getRequest(`new-dashboard-property-details/${this.batchNum}`)
            .then(res => {
                // if (res.data.error) {
                //   this.hideDiv = false;
                // }
                this.loading = false;
                // console.log("Property deatils", res);
                if (res.data.success) {
                this.tenantsdetails = res.data.tenants;
                this.rentDisbursment =  res.data.rent_disbursment;
                this.propertyDetails = res.data.property[0];
                this.outterDetails = res.data;
                }
            })
            .catch(err => {
                // console.log(err);
                this.loading = false;
                // this.loader = false;
            });
            } finally {
                // console.log("Closed connection");
            }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        }
    }
}
</script>



<style lang="scss" scoped>
    
.property-details {
    .col-md-4 {
        border-bottom: 1px solid #E5E7EB;
    }
    .col-md-4:last-child {
        border-bottom: none;
    }
    margin-bottom: 30px;
}
.details-item {
    h6 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 40px;
        color: #333333;
        text-align: left;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 25px;
        color: #555C74;
        text-align: left;
    }
}

.payment-history {
    .history-holder {
        background: #FAFAFA;
        border-radius: 4px;
        padding: 12px;
        margin-bottom: 15px;
        h4 {
            font-family: Lato;
            font-weight: 600;
            font-size: 16px;
            line-height: 125%;;
            color: #2B3352;
            text-align: left;
        }
        h5 {
            font-family: Lato;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #555C74;
            text-align: left;
        }
        small {
            font-family: Lato;
            font-weight: 400;
            font-size: 10.04px;
            line-height: 17.21px;
            color: #4B5563;
        }
    }
    
}

.add-tenant-btn {
    button {
        background: #0033ea;
        color: #ffffff;
        box-shadow: none;
        outline: 0;
        font-family: Lato;
        outline: 0;
        box-shadow: none;
    }
}

.modal-input {
    label {
        color: #333333;
        font-family: Lato;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        display: flex;
    }
    input, select {
        color: #4B5563;
        font-size: 16px;
        font-family: Lato;
    }
}
.search-btn {
    background: #00155F; //#0329ab
    color: #ffffff;
    font-family: Lato;
    outline: 0;
    box-shadow: none;
}
.cancel-submit {
    border: 1px solid #0329ab;
    color: #0329ab;
    font-family: Lato;
    outline: 0;
    box-shadow: none;
}
.submit-tenant {
    background: #0329ab;
    color: #ffffff;
    font-family: Lato;
    outline: 0;
    box-shadow: none;
}
// @media screen and (max-width: 599px) {
//     .tenant-button-section {
//         display: block;
//         .sheltaBtn {
//             width: 100%;
//         }
//     }
// }
</style>